import { css } from 'styled-components';

export default {
    h6: css`
        /* styleName: H6; */
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 29px;
        letter-spacing: 0.15000000596046448px;
        text-align: left;
    `,
    h5: css`
        /* styleName: H5; */
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 29px;
        letter-spacing: 0.15000000596046448px;
        text-align: left;
    `,
    body_1: css`
        /* styleName: Body 1; */
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 23px;
        letter-spacing: 0.5px;
        text-align: left;
    `,
    body_2: css`
        /* styleName: Body 2; */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        text-align: left;
    `,
    input_1: css`
        /* styleName: Body 2; */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        text-align: left;
    `,
    buttonText_1: css`
        /* styleName: Button Text 1; */
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 23px;
        letter-spacing: 0.5px;
        text-align: center;
    `,
    buttonText_2: css`
        /* styleName: Button Text 2; */
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.5px;
        text-align: center;
    `,
    sideBar_subHeader: css`
        font-size: 12px;
    `,
    sideBar_navItem: css`
        font-size: 14px;
    `,
};
